import { Project } from '../types/project';


export const useIsUseQuickQuestionSurvey = (projectItemConfig: Project['item']['config']) => {
  return projectItemConfig === 'quick-question';
};
